module.exports = __webpack_public_path__ + "img/image_album_deadly_sins_blanc.8b51b9d1.jpg";